export const TipoAcaoGeometriaDesenhada = {
    DIAGNOSTICO_SOCIOAMBIENTAL: 0
};
